/* ANIKO TRIPS — Tropical theme JS */
(function () {
  'use strict';

  var routes = window.routes || {};
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2200);
  }
  window.abToast = toast;

  /* ---------- cart drawer ---------- */
  var overlay = document.getElementById('cart-drawer-overlay');
  var drawer = document.getElementById('cart-drawer');

  function openDrawer() {
    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
  }
  function closeDrawer() {
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
  }
  window.abOpenCart = openDrawer;

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    var itemsWrap = document.getElementById('drawer-items');
    var foot = document.getElementById('drawer-foot');
    if (!itemsWrap) return;

    if (!cart.items || cart.items.length === 0) {
      itemsWrap.innerHTML = '<div class="drawer__empty"><div style="font-size:13px;letter-spacing:.1em;text-transform:uppercase">Your bag is empty</div><p style="font-size:11px;margin-top:10px;line-height:1.7">Go grab something for your next trip.</p></div>';
      if (foot) foot.classList.add('hidden');
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img class="line-item__media" src="' + item.image + '" alt="">'
        : '<div class="line-item__media"></div>';
      html += '<div class="line-item">' + img +
        '<div style="flex:1">' +
          '<div style="display:flex;justify-content:space-between"><span style="font-family:Syne,sans-serif;font-weight:700;font-size:13px;text-transform:uppercase">' + item.product_title + '</span><span style="font-size:12px;color:var(--blue)">' + money(item.final_line_price) + '</span></div>' +
          '<div style="font-size:10px;color:var(--muted);margin-top:4px">' + (item.variant_title ? item.variant_title + ' · ' : '') + money(item.final_price) + ' each</div>' +
          '<div style="display:flex;align-items:center;gap:14px;margin-top:10px">' +
            '<span class="qty-step" data-key="' + item.key + '" data-dir="-1" style="cursor:pointer;width:24px;height:24px;border:1px solid rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-size:14px">&minus;</span>' +
            '<span style="font-size:12px;min-width:14px;text-align:center">' + item.quantity + '</span>' +
            '<span class="qty-step" data-key="' + item.key + '" data-dir="1" style="cursor:pointer;width:24px;height:24px;border:1px solid rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-size:14px">+</span>' +
          '</div>' +
        '</div></div>';
    });
    itemsWrap.innerHTML = html;

    if (foot) {
      foot.classList.remove('hidden');
      var sub = document.getElementById('drawer-subtotal');
      if (sub) sub.textContent = money(cart.total_price);
    }
  }

  function fetchCart() {
    fetch(routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function stepQty(key, dir) {
    fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var q = Math.max(0, item.quantity + dir);
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart]');
    if (t) { e.preventDefault(); openDrawer(); fetchCart(); return; }
    if (e.target.closest('[data-close-cart]') || e.target.id === 'cart-drawer-overlay') { closeDrawer(); return; }
    var step = e.target.closest('.qty-step');
    if (step) { stepQty(step.getAttribute('data-key'), parseInt(step.getAttribute('data-dir'), 10)); return; }
  });

  /* ---------- add to cart (product form) ---------- */
  var addForms = document.querySelectorAll('[data-product-form]');
  addForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      if (btn && btn.disabled) return;
      var fd = new FormData(form);
      fetch(routes.cart_add_url + '.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          openDrawer();
          fetchCart();
          toast('Added to bag');
        });
    });
  });

  /* ---------- qty stepper on PDP ---------- */
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(1, v + parseInt(b.getAttribute('data-qty'), 10));
        input.value = v;
      });
    });
  });

  /* ---------- PDP gallery ---------- */
  var mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('[data-thumb]').forEach(function (th) {
    th.addEventListener('click', function () {
      var src = th.getAttribute('data-src');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      th.classList.add('is-active');
    });
  });

  /* ---------- variant swatches / sizes ---------- */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    group.querySelectorAll('[data-option-value]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        group.querySelectorAll('[data-option-value]').forEach(function (x) { x.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var hidden = group.parentElement.querySelector('input[data-option-input]');
        var label = group.parentElement.querySelector('[data-option-current]');
        if (hidden) hidden.value = opt.getAttribute('data-option-value');
        if (label) label.textContent = opt.getAttribute('data-option-value');
        if (window.abUpdateVariant) window.abUpdateVariant();
      });
    });
  });

  /* ---------- favorites (localStorage) ---------- */
  function getFavs() {
    try { return JSON.parse(localStorage.getItem('ab_favs') || '[]'); } catch (e) { return []; }
  }
  function setFavs(a) { localStorage.setItem('ab_favs', JSON.stringify(a)); }
  document.querySelectorAll('[data-fav]').forEach(function (btn) {
    var id = btn.getAttribute('data-fav');
    if (getFavs().indexOf(id) > -1) {
      btn.classList.add('is-on');
      document.querySelectorAll('[data-fav="' + id + '"]').forEach(function (b) { b.textContent = '\u2665'; });
    }
    btn.addEventListener('click', function () {
      var favs = getFavs();
      var i = favs.indexOf(id);
      var on;
      if (i > -1) { favs.splice(i, 1); on = false; } else { favs.push(id); on = true; }
      setFavs(favs);
      document.querySelectorAll('[data-fav="' + id + '"]').forEach(function (b) {
        b.classList.toggle('is-on', on);
        b.textContent = on ? '\u2665' : '\u2661';
      });
      toast(on ? 'Saved to favourites' : 'Removed from favourites');
    });
  });

  /* ---------- variant matching ---------- */
  (function () {
    var dataEl = document.getElementById('product-variants-data');
    var select = document.getElementById('variant-select');
    if (!dataEl || !select) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function currentOptions() {
      var inputs = document.querySelectorAll('input[data-option-input]');
      var vals = [];
      inputs.forEach(function (inp) { vals[parseInt(inp.getAttribute('data-index'), 10)] = inp.value; });
      return vals;
    }

    window.abUpdateVariant = function () {
      var opts = currentOptions();
      var match = variants.filter(function (v) {
        for (var i = 0; i < opts.length; i++) {
          if (opts[i] && v.options[i] !== opts[i]) return false;
        }
        return true;
      })[0];
      if (!match) return;
      select.value = match.id;
      var priceEl = document.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = money(match.price);
      var addBtn = document.querySelector('[data-add-btn]');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    };
  })();

  /* ---------- FAQ accordion + search + topics ---------- */
  document.querySelectorAll('[data-faq]').forEach(function (faq) {
    var q = faq.querySelector('.faq__q');
    if (q) q.addEventListener('click', function () { faq.classList.toggle('is-open'); });
  });

  var faqSearch = document.getElementById('faq-search');
  var faqItems = Array.prototype.slice.call(document.querySelectorAll('[data-faq]'));
  var topics = Array.prototype.slice.call(document.querySelectorAll('[data-topic]'));
  var activeTopic = 'all';

  function applyFaqFilter() {
    var q = (faqSearch && faqSearch.value || '').trim().toLowerCase();
    var shown = 0;
    faqItems.forEach(function (item) {
      var text = item.getAttribute('data-search') || '';
      var topic = item.getAttribute('data-faq-topic') || '';
      var matchSearch = !q || text.toLowerCase().indexOf(q) > -1;
      var matchTopic = q ? true : (activeTopic === 'all' || topic === activeTopic);
      var ok = matchSearch && matchTopic;
      item.hidden = !ok;
      if (ok) shown++;
    });
    var none = document.getElementById('faq-none');
    if (none) none.classList.toggle('hidden', shown !== 0);
    var label = document.getElementById('faq-topic-label');
    if (label) label.textContent = q ? 'Search results' : (activeTopic === 'all' ? 'Popular questions' : activeTopic);
  }
  if (faqSearch) faqSearch.addEventListener('input', applyFaqFilter);
  topics.forEach(function (tp) {
    tp.addEventListener('click', function () {
      var name = tp.getAttribute('data-topic');
      activeTopic = (activeTopic === name) ? 'all' : name;
      topics.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-topic') === activeTopic); });
      if (faqSearch) faqSearch.value = '';
      applyFaqFilter();
    });
  });

})();
